import React from 'react'
import T from 'prop-types'
// import { get } from 'lodash'
// import useSWR from 'swr'

import Wizard from '../wizard'

export default function BookingPage({ match }) {
  return (
    <Wizard baseUrl={`/${match.params.orgUnit}/${match.params.bookingType}`} />
  )
}

BookingPage.propTypes = {
  match: T.object.isRequired,
}
